export default __webpack_public_path__ + "static/media/icona-SEARCH.e5c9d180.svg";